import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../../components/ui/logo';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
const Register = () => {
  return <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <Logo size="lg" />
          </div>
          <h2 className="mt-2 text-xl font-semibold">Konto erstellen</h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Registrieren Sie sich, um auf das Musikschulverwaltungssystem
            zuzugreifen
          </p>
        </div>
        <form className="mt-8 space-y-6">
          <div className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium">
                Vollständiger Name
              </label>
              <Input id="name" type="text" autoComplete="name" />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium">
                E-Mail-Adresse
              </label>
              <Input id="email" type="email" autoComplete="email" />
            </div>
            <div>
              <label htmlFor="password" className="block text-sm font-medium">
                Passwort
              </label>
              <Input id="password" type="password" autoComplete="new-password" />
            </div>
          </div>
          <div>
            <Button type="submit" className="w-full">
              Konto erstellen
            </Button>
          </div>
        </form>
        <p className="mt-4 text-center text-sm text-muted-foreground">
          Haben Sie bereits ein Konto?{' '}
          <Link to="/login" className="font-medium text-primary hover:underline">
            Anmelden
          </Link>
        </p>
      </div>
    </div>;
};
export default Register;